import { Injectable } from "@angular/core";
import { Store, Action, action } from "@smdlib/statex/@angular";
import { AppState } from '@smdapp/flux/state/app.state';
import { TipoAutenticacaoEnum } from "../../shared/enums/tipo-autenticacao.enum";

export class RegistrarTipoAutenticacaoAction extends Action { constructor(public tipoAutenticacao: TipoAutenticacaoEnum) { super(); } }


@Injectable()
export class AutenticacaoStore extends Store
{

    constructor()
    {
        super();
    }

    @action()
    registrarTipoAutenticacao(state: AppState, act: RegistrarTipoAutenticacaoAction): Promise<AppState>
    {
        return new Promise((resolve, reject) =>
        {
            resolve({tipoAutenticacao: act.tipoAutenticacao});
        });

    }

}
